const LOGIN_CONTEXT_KEY = "postLoginContext";
const LOGIN_REDIRECT_KEY = "postLoginRedirectPath";

export function setPostLoginContext(context = {}) {
  if (context?.postLoginRedirectPath) {
    sessionStorage.setItem(LOGIN_REDIRECT_KEY, context.postLoginRedirectPath);
  }

  sessionStorage.setItem(
    LOGIN_CONTEXT_KEY,
    JSON.stringify({
      reason: context.reason || "share_open",
      resourceType: context.resourceType || "record",
      resourceId: context.resourceId || "",
    }),
  );
}

export function getPostLoginContext() {
  const raw = sessionStorage.getItem(LOGIN_CONTEXT_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}

export function clearPostLoginContext() {
  sessionStorage.removeItem(LOGIN_CONTEXT_KEY);
  sessionStorage.removeItem(LOGIN_REDIRECT_KEY);
}

export function peekPostLoginRedirectPath() {
  return sessionStorage.getItem(LOGIN_REDIRECT_KEY);
}

export { LOGIN_REDIRECT_KEY };
